import { connect } from "react-redux";
import { fetchBlock, fetchList, fetchMoreBlock, resetBlock } from "../store/actions/blocks";

import Info from '../components/blocks/Info';
import List from '../components/blocks/List';
import withAuth from '../hocs/withAuth';

function mapStateToProps(state, ownProps) {
  let editId = null;
  if (ownProps.match) editId = ownProps.match.params.id;
  if (ownProps.editId) editId = ownProps.editId;
  if (ownProps.blockId) editId = ownProps.blockId;
  return {
    errors: state.errors,
    user: state.currentUser.user,
    workoutCats: state.workoutCats,
    blockCats: state.blockCats,
    blocks: state.blocks.data,
    blockInfo: state.blocks.info,
    isLoadMoreListing: state.blocks.isLoadMore,
    editId: editId,
    ...ownProps
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchBlock: (blockId) => {
      return dispatch(fetchBlock(blockId));
    },
    fetchList: (query) => {
   		return dispatch(fetchList(query));
		},
    fetchMoreBlocks: (query) => {
   		return dispatch(fetchMoreBlock(query));
		},
    resetBlocks:  () => {
			return dispatch(resetBlock());
		}
  }
}
export const BlockInfo = withAuth(connect(mapStateToProps, mapDispatchToProps)(Info));

export const MyBlocks = withAuth(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Blocks.js